export default "__VITE_ASSET__gLqIH9OV__"